import { object, string, number } from 'yup'

export interface IStoreAwardSchema {
  googleSheetsUrl: string
  email: string
  roundNumber: number
}

export const StoreAwardSchema = object<IStoreAwardSchema>({
  googleSheetsUrl: string().required('Must enter a URL'),
  email: string().required('Must enter an email address'),
  roundNumber: number().required('Must enter a round number').typeError('Please enter a number'),
})
